<template>
  <div>
    <div class="bg-box"></div>
    <div class="list-layer-wrap">
      <div class="btn-wrap">
        <span>事件信息</span>
        <Icon type="md-close" size="20" class="close-btn" @click="closeLayer" />
      </div>
      <div class="container-box flex-space-between" style="align-items: start">
        <div style="width: 75%" ref="videoTitle">
          <div style="width: 100%; margin-bottom: 15px">
            <div class="list-title">
              <span class="list-title-line"></span>告警流程
            </div>
            <div style="width: 100%; overflow-x: auto">
              <div class="timeLinebox scrollDIV2">
                <ul class="timeLinelist">
                  <li class="timeLinelis">
                    <div
                      class="timeLine"
                      style="margin-left: 15px"
                      v-if="isEnd || line.length > 0"
                    ></div>
                    <span class="timeLinespanradio"></span>
                    <span class="timeLinespanfont" style="line-height: 17px">
                      {{ detailInfo.content }}
                    </span>
                  </li>
                  <li class="timeLinelislinebox">
                    <div class="timeLinelisline">
                      <div class="colorGray">
                        {{ detailInfo.ctime | timestampToTime }}
                      </div>
                    </div>
                  </li>
                  <template v-for="(item, index) in line">
                    <li class="timeLinelis">
                      <div class="timeLine" v-if="line.length > 1 || isEnd"></div>
                      <span class="timeLinespanradio"></span>
                      <span class="timeLinespanfont">
                        <span class="btn" v-if="item.stateCode == '0'"
                          >发生</span
                        >
                        <span class="btn" v-if="item.stateCode == '1'"
                          >响应</span
                        >
                        <span class="btn" v-if="item.stateCode == '3'"
                          >报修</span
                        >
                        <span class="btn" v-if="item.stateCode == '22'">{{
                          item.customName
                        }}</span>
                        <span class="btn" v-if="item.stateCode == '21'"
                          >误报</span
                        >
                      </span>
                    </li>
                    <li class="timeLinelislinebox">
                      <div class="timeLinelisline">
                        <div class="colorGray">
                          {{ item.recordTime | timestampToTime }}
                        </div>
                        <div style="padding: 0 100px">
                          <span v-if="item.operatorName"
                            >【{{ item.operatorName }}】</span
                          >
                          <span v-if="item.stateCode == '1'">进行【响应】</span>
                          <span v-if="item.stateCode == '3'">进行【报修】</span>
                          <span v-if="item.stateCode == '21'"
                            >处理为【误报】</span
                          >
                          <span v-if="item.stateCode == '22'"
                            >处理为【{{ item.customName }}】</span
                          >
                        </div>
                      </div>
                    </li>
                  </template>
                  <li class="timeLinelis" v-if="isEnd">
                    <span class="timeLinespanradio"></span>
                    <span class="timeLinespanfont"> 已结束 </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 50%; padding-right: 10px">
              <div class="list-title">
                <span class="list-title-line"></span>设备信息
              </div>
              <div class="right-box">
                <ul>
                  <p>单位信息</p>
                  <li>单位信息：{{ detailInfo.orgName }}</li>
                  <li>所属区域：{{ detailInfo.areaName }}</li>
                  <li>消防安全责任人：{{ detailInfo.chargePersonName }}</li>
                  <li>联系方式：{{ detailInfo.chargePersonTel }}</li>
                  <li style="width: 100%">
                    单位地址：{{ detailInfo.address }}
                  </li>
                  <p>设施信息</p>
                  <li>
                    <span>设施名称：</span
                    ><span>{{ detailInfo.deviceName }}</span>
                  </li>
                  <li>所属建筑：{{ detailInfo.buildingName }}</li>
                  <li>系统形式：{{ detailInfo.systemFormName }}</li>
                  <li>设施类型：{{ detailInfo.deviceTypeName }}</li>
                </ul>
              </div>
            </div>
            <div style="width: 50%; position: relative">
              <div class="list-title">
                <span class="list-title-line"></span
                >{{ state.showVideo ? "视频监控" : "地图定位" }}
              </div>
              <div class="record-btn" v-if="detailInfo.hlsAddr">
                <div class="btn-r">
                  <div
                    class="location-btn"
                    :class="state.showPosition ? 'active1' : ''"
                    @click="clickEchart()"
                  >
                    &nbsp;<Icon type="ios-pin-outline" size="17" />定位
                  </div>
                  <div
                    class="video-btn"
                    :class="state.showVideo ? 'active2' : ''"
                    @click="
                      state.showVideo = true;
                      state.showPosition = false;
                    "
                  >
                    视频
                  </div>
                </div>
              </div>
              <div class="videoList" v-if="state.showVideo">
                <videoPlay
                  v-if="detailInfo.hlsAddr"
                  :previewUrl="detailInfo.hlsAddr"
                  :videoDeviceId="detailInfo.source=='5'?detailInfo.partId:detailInfo.id"
                  :height="320"
                  :width="videoWidth"
                  :showClose="false"
                  :id="detailInfo.id"
                  style="margin-top: -48px"
                />
                <p
                  v-else
                  style="text-align: center; padding-top: 20px; width: 100%"
                >
                  暂无数据
                </p>
              </div>
              <div v-show="state.showPosition">
                <div
                  style="width: 100%; height: 318px; border-radius: 0 0 5px 5px"
                  id="company-map"
                  v-if="detailInfo.position"
                ></div>
                <p
                  v-else
                  style="text-align: center; padding-top: 20px; width: 100%"
                >
                  暂无数据
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 23%">
          <div class="list-title">
            <span class="list-title-line"></span>警情处置
          </div>
          <div class="warning-instance">
            <div class="describe">
              <p>警情描述</p>
              <Input
                v-model="describeTxt"
                type="textarea"
                :autosize="{ minRows: 9, maxRows: 9 }"
                placeholder="请输入警情内容"
              />
              <div class="lable flex-space-between">
                <p>处理方式</p>
                <p
                  v-show="
                    detailInfo.msgType == 'flamingFire' &&
                    detailInfo.gatewayType == 4
                  "
                  style="color: #74d9ff; cursor: pointer"
                  @click="controlClick(detailInfo)"
                >
                  <i
                    class="iconfont icon-kongzhitai"
                    style="margin-right: 5px"
                  ></i
                  >控制台
                </p>
              </div>
              <div class="btn-box">
                <div
                  class="item-btn"
                  :class="{ active: processingStatus == 2 }"
                  @click="handleClick(2)"
                >
                  <i
                    class="iconfont icon-duihao"
                    style="margin-right: 5px"
                    v-show="processingStatus == 2"
                  ></i
                  >已处理
                </div>
                <div
                  class="item-btn"
                  :class="{ active: processingStatus == 1 }"
                  @click="handleClick(1)"
                >
                  <i
                    class="iconfont icon-duihao"
                    style="margin-right: 5px"
                    v-show="processingStatus == 1"
                  ></i
                  >误报
                </div>
                <div
                  v-show="detailInfo.deviceId"
                  class="item-btn"
                  :class="{ active: processingStatus == 3 }"
                  @click="handleClick(3)"
                >
                  <i
                    class="iconfont icon-duihao"
                    style="margin-right: 5px"
                    v-show="processingStatus == 3"
                  ></i
                  >报修
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="footer flex-flex-end"
        v-show="detailInfo.state == '0' || detailInfo.state == '1'"
      >
        <Button
          @click="closeLayer"
          style="background-color: rgba(231, 231, 231, 0.2); color: #fff"
          >取消</Button
        >
        <Button
          @click="submitWarningInstance"
          type="primary"
          style="background-color: #0256ff"
          >确定</Button
        >
      </div>
    </div>
  </div>
</template>
<script>
import marker3Img from "@/assets/marker/dingwei.png"; //正常
import videoPlay from "./videoPlay/videoPlay.vue";
export default {
  name: "",
  data: () => ({
    timeLineData: {},
    line: [],
    detailInfo: {},
    state: {
      showPosition: true,
      showThreeModal: false,
      three_model_url: "",
      showVideo: false,
      videoList: [],
    },
    orgId: "",
    eventType: "",
    id: "",
    isEnd: false,
    videoWidth: 0,
    eventList: [
      {
        name: "火警",
        id: "flamingFire",
      },
      {
        name: "报警",
        id: "fire",
      },
      {
        name: "预警",
        id: "warn",
      },
      {
        name: "故障",
        id: "fault",
      },
    ],
    describeTxt: "",
    handlingMethod: "1",
    processingStatus: 2,
  }),
  components: { videoPlay },
  props: ["eventInfo", "isShowPanel"],
  watch: {
    eventInfo: function (res) {
      console.log(res);
    },
    isShowPanel: {
      handler(newVal, oldVal) {
        console.info("value changed 2", newVal);
      },
      deep: true,
    },
  },
  filters: {
    timestampToTime(timestamp) {
      if (timestamp == undefined) {
        return "";
      } else {
        var date = new Date(timestamp); //时间戳 -- 如果date为13位不需要乘1000  3-11修改
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.videoWidth = this.$refs.videoTitle.offsetWidth / 2;
    });
    this.orgId = this.eventInfo.data.cid;
    this.id = this.eventInfo.data.id;
    this.eventList.forEach((item, index) => {
      if (index == this.eventInfo.baoOrYu) {
        this.eventType = item.id;
      }
    });
    this.getDetail();
  },
  methods: {
    getDetail() {
      return new Promise((resolve, reject) => {
        let dataObj = {
          type: "get",
          url: "/mcbw/alarm_stats/alarm_line",
          obj: {
            orgId: this.orgId,
            eventType: this.eventType,
            id: this.id,
          },
        };
        this.line = [];
        this.$Axios(dataObj).then((res) => {
          if (res.data.success) {
            this.detailInfo = res.data.data;
            this.describeTxt = res.data.data.handleContent;
            if (
              !res.data.data.handleMethod ||
              res.data.data.handleMethod == "3"
            ) {
              this.processingStatus = 2;
            } else if (
              res.data.data.handleMethod &&
              res.data.data.handleMethod == "4"
            ) {
              this.processingStatus = 1;
            } else if (
              res.data.data.handleMethod &&
              res.data.data.handleMethod == "2"
            ) {
              this.processingStatus = 3;
            }
            var line = res.data.data.line || [];
            this.state.videoList = res.data.data.cameras || [];
            line &&
              line.forEach((item) => {
                if (item.stateCode == "22" || item.stateCode == "21") {
                  let one = line.some((item) => item.stateCode == "3");
                  item.customName = one ? "维修结束" : "已解决";
                  this.isEnd = true;
                }
                if (item.stateCode !== 0) {
                  this.line.push(item);
                }
              });

            if (this.detailInfo.hlsAddr && this.detailInfo.hlsAddr !== "") {
              this.state.showVideo = true;
              this.state.showPosition = false;
            } else {
              this.mapInit();
            }
            resolve(res.data);
          }
        });
      });
    },
    clickEchart() {
      this.state.showVideo = false;
      this.state.showPosition = true;
      this.mapInit();
    },
    mapInit() {
      //初始化地图
      if (!this.detailInfo.position) {
        return;
      }
      let position = [
        this.detailInfo.position.split(",")[0],
        this.detailInfo.position.split(",")[1],
      ];
      console.log(position);
      this.$nextTick(() => {
        this.map = new AMap.Map("company-map", {
          resizeEnable: true,
          center: position,
          zoom: 14,
          // dragEnable: false,
          // zoomEnable: false,
        });
        let labelMarker = new AMap.LabelMarker({
          position: position,
          zIndex: 16,
          // 将第一步创建的 icon 对象传给 icon 属性
          icon: {
            // 图标类型，现阶段只支持 image 类型
            type: "image",
            // 图片 url
            image: marker3Img,
            // 图片尺寸
            size: [30, 30],
            // 图片相对 position 的锚点，默认为 bottom-center
            anchor: "center",
          },
        });
        var labelsLayer = new AMap.LabelsLayer({
          zIndex: 1000,
          // 该层内标注是否避让
          collision: false,
          // 设置 allowCollision：true，可以让标注避让用户的标注
          allowCollision: false,
        });
        labelsLayer.add(labelMarker);
        this.map.add(labelsLayer);
      });
    },
    closeLayer() {
      this.$emit("closePanel", false);
    },
    handleClick(type) {
      console.log(type);
      this.processingStatus = type;
    },
    controlClick(activeItem) {
      activeItem.cid = JSON.parse(JSON.stringify(activeItem.orgId));
      this.$emit("setOpenPasswordModel", activeItem);
    },
    consoleClosed() {
      // 控制台关闭后重新显示视频模块
      this.state.showVideo = true;
    },
    hideVideoModule() {
      // 隐藏视频模块
      this.state.showVideo = false;
    },
    submitWarningInstance() {
      return new Promise((resolve, reject) => {
        let params = {
          aggDetails: {
            id: this.detailInfo.id,
          },
          handleState: this.processingStatus,
          msgType: this.detailInfo.msgType,
          handleNotes: this.describeTxt,
          orgId: this.detailInfo.orgId,
        };
        if (this.processingStatus == 3) {
          params.deviceId = this.detailInfo.deviceId;
        }
        let dataObj = {
          type: "post",
          url: "/mcbw/message_center/handle",
          obj: params,
        };
        this.$Axios(dataObj).then((res) => {
          if (res.data.success) {
            this.$Message.success(res.data.message);
            setTimeout(() => {
              this.$emit("upDataList", {});
            }, 1000);
            this.closeLayer();
            resolve(res.data);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-box {
  position: absolute;
  top: -620px;
  color: #fff;
  height: 920px;
  width: 200%;
  left: -50%;
  z-index: 259;
}
.container-box {
  padding: 20px;
}
.btn-wrap {
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #1b447b;
  > span {
    font-size: 16px;
    color: #ffffff;
  }
  .close-btn {
    width: 20px;
    height: 20px;
    margin-top: 10px;
    cursor: pointer;
  }
}
.list-layer-wrap {
  position: absolute;
  top: -540px;
  color: #fff;
  height: 710px;
  // width: 120%;
  width: 156%;
  left: -25%;
  background: #07132b;
  box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
  z-index: 260;
  .footer {
    border-top: 1px solid rgba(62, 117, 190, 0.5);
    padding-top: 10px;
    button {
      margin-right: 20px;
    }
  }
}
.timeLinebox {
  width: 100%;
  height: 140px;
  position: relative;
  overflow: hidden;
  background: #344b66;
  padding-top: 50px;
  border-radius: 0 0 5px 5px;
  color: #fff;
  .timeLine {
    height: 1px;
    border-bottom: 1px dashed #fff;
    position: absolute;
    width: 220px;
    margin-top: 8px;
    z-index: 7;
  }
  .timeLinelist {
    height: 20px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: left;
    flex-shrink: 0;
    padding-left: 95px;
    .timeLinelis {
      display: inline-block;
      width: 16px;
      height: 16px;
      position: relative;
      box-sizing: border-box;
      .timeLinespanradio {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: #4a90e2;
        border-radius: 50%;
        position: relative;
        z-index: 99;
      }

      .timeLinespanfont {
        width: 190px;
        text-align: center;
        position: absolute;
        top: -35px;
        left: -88px;
        .btn {
          border: 1px solid #979797;
          font-size: 13px;
          line-height: 20px;
          padding: 2px 10px;
          border-radius: 12px;
          display: inline-block;
        }
      }
    }

    .timeLinelislinebox {
      width: 206px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1px;
      font-size: 12px;
      flex-shrink: 0;
      .timeLinelisline {
        padding-top: 65px;
        margin-left: -230px;
        text-align: center;
        .colorGray {
          padding: 0 140px;
        }
      }
    }
  }
}

.videoList {
  // width: 530px;
  height: 320px;
  /* overflow: hidden; */
  padding: 15px 0;
  display: flex;
  > div {
    // padding: 5px;
    margin-top: -10px !important;
  }
}
.record-btn {
  width: 150px;
  display: flex;
  position: absolute;
  margin-top: -33px;
  right: 15px;
  z-index: 99;
  .btn-l {
    display: flex;
    font-size: 17px;

    .tit-l {
      margin-right: 30px;
      line-height: 43px;
    }
  }

  .btn-r {
    display: flex;
    & > div {
      width: 62.82px;
      height: 24px;
      line-height: 24px;
      padding-left: 25px;
      background: #edfdfb;
      border-radius: 12px;
      font-size: 12px;
      cursor: pointer;
    }
    .location-btn {
      color: #1ac2a6;
      border: 1px solid #1ac2a6;
      padding-left: 2px;
      margin-right: 10px;
    }
    .active1 {
      background-color: #1ac2a6;
      color: #fff;
    }
    .video-btn {
      color: #4a90e2;
      border: 1px solid #4a90e2;
      background-image: url("../assets/images/shipin.png");
      background-repeat: no-repeat;
      background-position: 10px 3px;
      background-size: 13px 16px;
    }
    .active2 {
      background-color: #4a90e2;
      background-image: url("../assets/images/shipin2.png");
      color: #fff;
    }
  }
}

.list-title {
  line-height: 46px;
  width: 100%;
  height: 46px;
  background: #326ab7;
  border-radius: 7px 7px 0 0;
  color: #fff;
  padding-left: 15px;
  position: relative;
  z-index: 99;
  &-line {
    width: 3px;
    height: 20px;
    transform: rotate(1.74deg);
    border: 2px solid #4a90e2;
    display: inline-block;
    border-radius: 2px;
    margin-right: 10px;
    position: relative;
    top: 3px;
  }
}
.right-box {
  background: #344b66;
  border-radius: 0 0 7px 7px;
  padding: 15px;
  height: 320px;
  ul {
    font-size: 12px;
    color: #fff;
    p {
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      margin-bottom: 5px;
      margin-top: 8px;
    }
    li {
      display: inline-block;
      width: 46%;
      line-height: 30px;
      margin-bottom: 5px;
    }
  }
}
.footer-btn {
  display: inline-block;
  margin-bottom: 10px;
  width: 60px;
  height: 25px;
  background: #4a90e2;
  border-radius: 14px;
  margin: 5px auto;
  color: #fff;
  text-align: center;
  line-height: 25px;
  margin-top: 10px;
  font-size: 12px;
  cursor: pointer;
  &:nth-child(2) {
    background: #f39801;
    margin-left: 10px;
    margin-right: 10px;
  }

  &:nth-child(3) {
    background: #1eaf8e;
  }
}
.disabled {
  background: #ccc !important;
  cursor: not-allowed;
}
.box1 {
  background: #344b66;
  border-radius: 7px;
  padding: 15px;
  margin-top: 15px;
  width: 100%;
  .inp1 {
    background: #ffffff63;
    border-radius: 4px;
    width: 100%;
    border: 0px;
    color: #fff;
  }
}
.scrollDIV2::-webkit-scrollbar {
  height: 8px;
  cursor: pointer;
}
.scrollDIV2::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px #07132b;
}

.scrollDIV2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #344b66;
  border-radius: 5px;
}
/deep/.ant-pagination-item a {
  color: #f1f1f1;
}
/deep/ .ant-pagination-item-active a {
  color: #1890ff;
}
/deep/.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  display: none;
}
/deep/.warning-instance {
  height: 521px;
  background: #354b66;
  padding: 20px;
  .describe {
    p {
      margin-bottom: 10px;
    }
    .ivu-input {
      background-color: rgba(255, 255, 255, 0.2);
      border-color: rgba(255, 255, 255, 0.2);
    }
    .lable {
      margin: 50px 0 20px 0;
    }
  }
  .btn-box {
    .item-btn {
      background-color: #d4d4d4;
      color: #fff;
      border-radius: 8px;
      text-align: center;
      margin-bottom: 20px;
      line-height: 35px;
      cursor: pointer;
      &.active {
        background-color: #22c49f;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottomListDetail.vue